import { Components, Theme } from '@mui/material'

const MuiSkeleton: Components<Theme>['MuiSkeleton'] = {
  defaultProps: {
    animation: 'wave',
  },
}

export default MuiSkeleton
